// extracted by mini-css-extract-plugin
module.exports = {"swiperContent":"aa1cR8dY","swiper":"mt_f_Mrr","icon":"bQqF1b6H","list":"inqiyGKf","searchCard":"Ok_vu7wH","word":"VbfE5vf2"};